export const conditionalItems = {
  title: '条件货品',
  resourceName: '条件货品',
  titles: {
    list: '条件货品列表',
    create: '新增条件货品',
    edit: '编辑条件货品',
    addQuick: '快速新增',
  },
  sections: {
    basic: '基本信息',
    linkage: '企业关联信息',
    validity: '有效期与状态',
    note: '备注',
    audit: '系统信息',
  },
  units: {
    days: '天',
  },
  fields: {
    code: '条件货品编码',
    name: '条件货品名称',
    conditionGroup: '条件货品分组',
    groupName: '分组',
    conditionName: '条件名称',
    productCode: '关联产品',
    sampleItem: '示例货品',
    registeredCompany: '注册公司',
    exporterCompany: '出口公司',
    importerCompany: '进口公司',
    sampleTestRequired: '是否要求样品测试',
    certificate: '证书',
    licenseNumber: '许可证号',
    effectiveDate: '生效日期',
    expiryDate: '到期日期',
    warningDays: '预警时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    status: '状态',
    onOffAction: '开 / 关',
    note: 'Note',
    remark: '备注',
    actions: '操作',
  },
  filter: {
    country: '公司国家',
    allCountries: '全部',
  },
  countries: {
    VN: '越南',
    TQ: '中国',
  },
  status: {
    active: '启用',
    inactive: '停用',
    required: '必填',
    notRequired: '非必填',
  },
  validation: {
    conditionNameRequired: '请输入条件名称',
    companyRequired: '请选择完整的三家公司',
  },
  messages: {
    importDescription: '请选择符合模板的 Excel 文件导入条件货品数据。',
    importSuccess: '条件货品导入成功',
    importFailed: '条件货品导入失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    noData: '暂无条件货品数据',
    totalItems: '总计: {total} 条条件货品',
    createSuccess: '创建条件货品成功',
    updateSuccess: '更新条件货品成功',
    deleteSuccess: '删除条件货品成功',
    confirmDelete: '确认删除该项吗？',
  },
  import: {
    button: '导入',
    noSheet: '导入文件没有工作表',
    noData: '没有可导入的数据',
    success: '成功导入 {count} 行',
    failed: '导入失败',
  },
}
